<template>
  <div>
    <div class="mt-2">
      <recipient :model="schema.recipient" />
    </div>

    <div class="mt-2">
      <w-datepicker class="form-group" :model="schema.date" />
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import Recipient from './components/Recipient';

// @vuese
// Formularz pisma bieżącej wypłaty w widoku pojedynczego dokumentu
// @group ActionData
export default {
  components: { ...components, Recipient },
  props: {
    // schema
    schema: { type: Object, required: true }
  }
};
</script>
